import { Option } from '../../api/dashboardV7/option';

export class OptionsViewModel {
    public optionsTv?: Option[] = [];
    public optionsMobile?: Option[] = [];
    public optionsCybersecure?: Option[] = [];
}
